export default __webpack_public_path__ + "static/media/openssh.328773cd.svg";